import { FilterGroupInput } from '@/components/Form/components/Conditions/types';
import {
  AssignmentRestrictionInput,
  CreateUserCollectionGroupInput,
  GroupTypeEnum,
  VisibilitySettingsType,
} from '@/types/schema';

export type CreateUserGroupInput = Omit<CreateUserCollectionGroupInput, 'filterGroup'> & {
  filterGroup?: FilterGroupInput;
  contentVisibilitySettings?: VisibilitySettingsType | null;
  assignmentRestriction?: AssignmentRestrictionInput | null;
};

export enum FormSection {
  Basic = 'BASIC',
  Condition = 'CONDITION',
  Visibility = 'VISIBILITY',
  AssignmentRestriction = 'ASSIGNMENT_RESTRICTION',
}

export interface GroupEditorProps {
  type: GroupTypeEnum;
  groupId?: string;
  onSubmit?: (value: string) => void;
  onClose?: () => void;
}
